import React from 'react';
import { RadioGroup } from '@ff-os/shared-react/components/radio-group/RadioGroup';
import { SizeChoice } from '@gift-variable-plugins/size-attribute-shared/SizeAttributeOptions';
import { SizeAttributeRadio } from './SizeAttributeRadio';

export const SizeAttributeRadioGroup = ({
    selected, choices, update
}: Props) => (
    <RadioGroup>
        {choices.map(c => (
            <SizeAttributeRadio key={c.value}
                value={c.value} label={c.label} options={c.options}
                onClick={update} active={c.value === selected.value} />
        ))}
    </RadioGroup>
);

type Props = {
    selected: SizeChoice;
    choices: SizeChoice[];
    update: (value: string) => void;
};